import { Button } from "components/Button";
import { LARGE } from "shared/constants";
import { MaxWidth } from "components/MaxWidth";
import { SrcSet } from "components/SrcSet";
import cx from "classnames";
import styles from "./OffsetImageWithContentSection.module.css";

export const OffsetImageWithContentSection = ({
  title,
  body,
  button,
  image,
  isOnDark,
}) => {
  if (!title || !image) {
    return null;
  }

  return (
    <div className={cx(styles.container, { [styles.onDark]: isOnDark })}>
      <MaxWidth size={LARGE}>
        <div className={styles.grid}>
          <div className={styles.content}>
            <h2 className={styles.title}>{title}</h2>

            {body && <p className={styles.body}>{body}</p>}

            {button && (
              <div className={styles.button}>
                <Button {...button}>{button.label}</Button>
              </div>
            )}
          </div>

          {image && (
            <div className={styles.image}>
              <SrcSet
                alt={image.alt}
                sizes={[
                  { minWidth: 1280, width: 640 },
                  { minWidth: 768, width: 440 },
                  { minWidth: 1, width: 400 },
                ]}
                src={image.url}
              />
            </div>
          )}
        </div>
      </MaxWidth>
    </div>
  );
};
